import React, { useState, useEffect } from "react";
import "./HangarDetailedHeader.scss";
import { useTranslation } from "react-i18next";
import { NotificationEnabledIcon, NotificationDisabledIcon } from "../../pages/SvgIcons/SvgIcons";
import { notificationEnabledPersona } from "../../../helper/constants";
import { useSelector } from "react-redux";
import { HANGAR_DETAILED_VIEW } from "../../../helper/constants";
import Tooltip from "@mui/material/Tooltip";
const HangarDetailedHeader = (props) => {
   const { t } = useTranslation();
   const { userInformation } = useSelector((state) => state.userInformation);
   const [showEmailContent, setShowEmailContent] = useState(false);
   const [aircraftMakeModel, setAircraftMakeModel] = useState("");
   //Uncomment the below line for displaying email content only for pilot/air crew
   /*  const enabledEmailNotificationPersona=()=>{
      if(userInformation?.jobTitle!=="" && userInformation?.jobTitle!==undefined){
         if(notificationEnabledPersona.includes(userInformation?.jobTitle.toLowerCase())){
            setShowEmailContent(true);
         }else{
            setShowEmailContent(false);
         }
     }
          }; */
   useEffect(() => {
      //Uncomment the below line for displaying email content only for pilot/air crew
      // enabledEmailNotificationPersona();
      setAircraftMakeModel(`${props?.aircraftMake} / ${props?.aircraftModel}`);
   }, []);
   return (

      <div className="cls-hangarDetailedHeader">
         <div className="row">
            <div className="col-12">
               <Tooltip title={aircraftMakeModel} arrow placement="right"
                  componentsProps={{
                     tooltip: {
                        sx: {
                           backgroundColor: "#384348",
                           fontFamily: "PP Telegraf",
                           fontWeight: "400",
                           color: "#FFFFFF",
                        },
                     },
                     arrow: {
                        sx: {
                           color: "#384348",
                        },
                     },
                  }}
               >
                  <span className="cls-hangarDetailedTitle">{aircraftMakeModel}</span>
               </Tooltip>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               <span className="cls-hangarDetailedName">
                  {props?.aircraftName ? props?.aircraftName : "N/A"}
               </span>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               <span className="cls-hangarDetailedVersion">
                  {`FMS: ${props?.fms}`}
               </span>
            </div>
         </div>
         <div className="row">
            <div className="col-12">
               {/*  Uncomment the below line for displaying email content only for pilot/air crew */}
               {/*  {props?.notificationFlag===true && showEmailContent ?( */}
               {props?.notificationFlag === true ? (
                  <>
                     <span><NotificationEnabledIcon /></span>
                     <span className="cls-hangarEmailHeader">{t(HANGAR_DETAILED_VIEW.TITLE_EMAIL_ENABLED)}</span>
                  </>
               ) :/* (showEmailContent && */
                  (
                     <>
                        <span><NotificationDisabledIcon /></span>
                        <span className="cls-hangarEmailHeader">{t(HANGAR_DETAILED_VIEW.TITLE_EMAIL_DISABLED)}</span>
                     </>
                  )
                  /* ) */
               }
            </div>
         </div>
      </div>
   );
};

export default HangarDetailedHeader;